'use client';

import { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  safePostHogGetFeatureFlag,
  isPostHogAvailable,
  safePostHogOnFeatureFlags,
} from 'utils/posthogHelpers';

/** Fires PostHog exposure event. URL injection moved to useHomepageVariant. */
const ExperimentUtmInjector = ({ flagKey }) => {
  useEffect(() => {
    if (!flagKey) return;

    const fireExposure = () => {
      safePostHogGetFeatureFlag(flagKey);
    };

    if (isPostHogAvailable()) {
      fireExposure();
    }

    safePostHogOnFeatureFlags(() => {
      fireExposure();
    });
  }, [flagKey]);

  return null;
};

ExperimentUtmInjector.propTypes = {
  flagKey: PropTypes.string,
};

export default ExperimentUtmInjector;
